module.exports = __webpack_public_path__ + "static/media/clover.03d4c6d2.png";